import * as Yup from "yup";
import checkout from "layouts/sub-organization/components/sub-organization-details/schemas/subOrganizationForm";

const {
  formField: { subOrganizationKey, country, city, district, address, phone, email, organization },
} = checkout;

export default {
  validation: Yup.object().shape({
    [subOrganizationKey.name]: Yup.string().required(subOrganizationKey.errorMsg),
    [country.name]: Yup.string().nullable(),
    [city.name]: Yup.string().nullable(),
    [district.name]: Yup.string().nullable(),
    [address.name]: Yup.string().nullable(),
    [phone.name]: Yup.string().max(11, phone.invalidMsg).nullable(),
    [email.name]: Yup.string().email(email.invalidMsg).nullable(),
    [organization.name]: Yup.object().required(organization.errorMsg),
  }),
};
